import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../molecules/accordion-item-plus/index.js';

class AccordionPlus extends s {
    constructor() {
        super(...arguments);
        this.id = '';
        this.accordionState = 'closed';
        this.rtl = false;
        this.boundHandleAccordionToggle = (e) => this.handleAccordionToggle(e);
        this.boundHandleArrowNavigation = (e) => this.handleArrowNavigation(e);
        this.handleSlotChange = () => {
            this.propagateRtl();
            this.applySectionBehavior();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('accordion-toggle', this.boundHandleAccordionToggle);
        this.addEventListener('accordion-arrow-navigation', this.boundHandleArrowNavigation);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('accordion-toggle', this.boundHandleAccordionToggle);
        this.removeEventListener('accordion-arrow-navigation', this.boundHandleArrowNavigation);
    }
    firstUpdated() {
        this.applySectionBehavior();
        this.propagateRtl();
    }
    updated(changedProperties) {
        if (changedProperties.has('accordionState')) {
            this.applySectionBehavior();
        }
        if (changedProperties.has('rtl')) {
            this.propagateRtl();
        }
    }
    getAllAccordionItems() {
        const slot = this.renderRoot.querySelector('slot[name="accordion-item-updated"]');
        return (slot === null || slot === void 0 ? void 0 : slot.assignedElements()) || [];
    }
    static setItemExpanded(accordionElement, value) {
        const item = accordionElement;
        item.expanded = value;
    }
    propagateRtl() {
        const items = this.getAllAccordionItems();
        items.forEach(item => {
            if (this.rtl) {
                item.setAttribute('rtl', '');
            }
            else {
                item.removeAttribute('rtl');
            }
        });
    }
    handleAccordionToggle(e) {
        const { expanded, item } = e.detail;
        if (expanded) {
            // Wait for the clicked item to update first, then collapse others
            requestAnimationFrame(() => {
                const allItems = this.getAllAccordionItems();
                allItems.forEach(accordionItem => {
                    if (accordionItem !== item) {
                        AccordionPlus.setItemExpanded(accordionItem, false);
                    }
                });
            });
        }
    }
    handleArrowNavigation(e) {
        var _a;
        const { direction, currentItem } = e.detail;
        const items = this.getAllAccordionItems();
        if (items.length === 0)
            return;
        const currentIndex = items.indexOf(currentItem);
        if (currentIndex === -1)
            return;
        let targetIndex;
        if (direction === 'down') {
            targetIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
        }
        else {
            targetIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
        }
        const targetItem = items[targetIndex];
        if (!targetItem || targetItem.disabled)
            return;
        const targetTrigger = (_a = targetItem.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.accordion__trigger');
        if (targetTrigger) {
            targetTrigger.focus();
        }
    }
    applySectionBehavior() {
        const items = this.getAllAccordionItems();
        if (!items || items.length === 0)
            return;
        requestAnimationFrame(() => {
            switch (this.accordionState) {
                case 'first':
                    items.forEach((item, index) => AccordionPlus.setItemExpanded(item, index === 0));
                    break;
                case 'open':
                    items.forEach(item => AccordionPlus.setItemExpanded(item, true));
                    break;
                case 'closed':
                    items.forEach(item => AccordionPlus.setItemExpanded(item, false));
                    break;
            }
        });
    }
    render() {
        return $ `<div class="accordion-plus-wrapper"><slot name="accordion-item-updated" @slotchange="${this.handleSlotChange}"></slot></div>`;
    }
}
__decorate([
    e({ type: String })
], AccordionPlus.prototype, "id", void 0);
__decorate([
    e({ type: String })
], AccordionPlus.prototype, "accordionState", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], AccordionPlus.prototype, "rtl", void 0);
customElements.define('cvt-accordion-plus', AccordionPlus);

export { AccordionPlus };
